import shiftMaster from './ShiftMaster'

export default shiftMaster;
